import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE, REGISTER,
  REHYDRATE
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';

import { configureStore as configureStoreTk } from '@reduxjs/toolkit';

import configureRootSaga from './configureRootSaga';

const defaultPersisConfig = {
  key: 'root',
  storage
};

export function configureStore(
  reducers,
  {
    middlewares = [],
    persistConfig = {},
    sagas = [],
    numberOfPersistedReducers = 1
  } = {}
) {
  const persistedReducer = persistReducer(
    {
      ...defaultPersisConfig,
      ...persistConfig
    },
    reducers
  );

  const sagaMiddleware = createSagaMiddleware();

  const store = configureStoreTk({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER
        ]
      }
    }).concat([...middlewares, sagaMiddleware]),
    devTools: import.meta.env.NX_ENABLE_REDUX_DEVTOOLS_EXTENSION === 'true'
  });

  const persistor = persistStore(store);

  sagaMiddleware.run(configureRootSaga(sagas, numberOfPersistedReducers));

  return { store, persistor };
}

export default configureStore;
